import { useEffect, useRef, useState } from "react";
import Image from "../images/Image";
import InputLabel from "../inputfields/InputLabel";
import SearchWithDropdown from "./SearchWithDropdown";
import DropDownModel from "./DropDownModel";
import ErrorMessage from "../ErrorMessages/ErrorMessage";
import DropdownFramer from "../framerMotion/DropdownFramer";
import InputShimmer from "../inputfields/InputShimmer";
import { inputFieldContent } from "../inputfields/InputFieldContent";
import useTranslation from "../CustomHooks/useTranslation";
import ToolTip from "../ToolTip/ToolTip";


interface DropdownButtonProps {
  labelName: string;
  id: string;
  errorMessage?: string;
  required?: boolean;
  onChange?: (id: string, value: string) => void; // Accepts both id and value
  tabIndex: number;
  options: string[];
  selectedValue?: string;
  handleSearchValue?: (value: string, id: string) => void;
  disabled?: boolean;
  noSearch?: boolean;
  className?: string;
  editLoading?: boolean;
  modalStyle?: string;
  customWidth?: boolean;
  loadMoreOptions?: (params: any, dropdownClick?: string) => void;
  testId?:string;
  setSearchedAccount?: (value: string) => void;
  dropdownTestId?:string;
  dropdownTopClass?:string;
  dropDownOpen?: boolean;
  setDropDownOpen?: (value: boolean) => void;
  toolTipClassName?: string;
  placeholder?: string;
}

export default function DropdownButtonForSearch({
  labelName,
  id,
  errorMessage,
  dropdownTopClass,
  required,
  onChange,
  // handleSearchValue = () => null,
  options,
  selectedValue,
  disabled,
  noSearch = false,
  editLoading,
  className,
  modalStyle,
  customWidth,
  testId,
  loadMoreOptions,
  setSearchedAccount,
  dropdownTestId,
  dropDownOpen,
  toolTipClassName,
  setDropDownOpen,
  placeholder
}: DropdownButtonProps) {
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [buttonWidth,setButtonWidth] = useState(0)
  const { translate } = useTranslation(inputFieldContent);
  const [searchValue, setSearchValue] = useState('');
  const handleSearchValue = (value: string, id: string) => {
    setSearchValue(value);
    setSearchedAccount?.(value);
    if (loadMoreOptions && value) {
      loadMoreOptions(value);
    }
  }
  const handleSelect = (value: string, action: boolean) => {
    if (onChange) {
      onChange(id, value); // Pass both `id` and `value`
    }
    handleSearchValue(value, id);
    setIsOpen(action);
    if (setDropDownOpen) {
      setDropDownOpen(action);
    }
  };

  const handleSearch = (value: string) => {
    handleSearchValue(value, id);
  };
  const handleClose = (action: boolean) => {
    handleSearchValue("", id);
    loadMoreOptions?.("", "dropdownClick");
    setIsOpen(action);
    if (setDropDownOpen) {
      setDropDownOpen(action);
    }
  };

  useEffect(() => {
    if (buttonRef.current) {
      setButtonWidth(buttonRef.current.offsetWidth);
    }
  }, [isOpen, dropDownOpen]);
  return (
    <DropDownModel isOpen={dropDownOpen ? dropDownOpen : isOpen} handleClose={handleClose} modalStyle={modalStyle}>
      <InputLabel labelName={labelName} id={id} required={required} />

      {editLoading ? <InputShimmer /> : <>
        <button
          ref={buttonRef}
          id={id}
          type="button"
          data-testid={testId || id}
          className={`${className} bg-white w-80 h-14 py-5 pr-[15px] disabled:bg-disable_fill disabled:border-disable_stroke pl-2.5 focus:pl-[9px] border rounded-lg text-subTitle outline-none focus:border-2 flex justify-between items-center ${errorMessage ? "border-negative" : "border-P_light_active"
            }`}
          disabled={disabled}
          onClick={() => handleClose(dropDownOpen ? !dropDownOpen : !isOpen)}
          // tabIndex={tabIndex}
        >
          <span
            className={`${selectedValue ? "text-primary_text" : "text-secondary_text"} group w-[95%] truncate flex flex-1 text-subTitle`}
          >
            <p className=" truncate">{selectedValue || translate(`Select ${placeholder ? placeholder : labelName.toLowerCase()}`)}</p>
          {selectedValue && <ToolTip ToolTipItem={selectedValue || ""} top={`left-0 ${toolTipClassName ? toolTipClassName : 'top-[1rem]'} `} />}
          </span>
          <DropdownFramer
            isDropdownVisible={dropDownOpen ? dropDownOpen : isOpen}
          >
            <Image src={disabled ? "arrow_light" : "dropdown-down-arrow"} />
          </DropdownFramer>
        </button>
      </>}
      {(dropDownOpen || isOpen) && (
        <SearchWithDropdown
          options={options}
          handleSearchValue={handleSearch}
          id={id}
          onSelect={handleSelect} // Pass `handleSelect` as the callback
          noSearch={noSearch}
          className={className}
          style={{ width: buttonWidth }}
          isInfiniteDropdown={true}
          fetchMoreData={loadMoreOptions}
          dropdownTestId={dropdownTestId}
          dropdownTopClass={dropdownTopClass}
          // dynamicDropdown={true}
        />
      )}
      {errorMessage && <ErrorMessage errorMessage={errorMessage} />}
    </DropDownModel>
  );
}
